module.exports = __webpack_public_path__ + "fonts/20bbccf.woff2";